// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iconWrapper{text-align:center}", "",{"version":3,"sources":["webpack://src/components/AssetsResoursesWithSelectLabel/AssetsResource.scss"],"names":[],"mappings":"AAAA,aACE,iBAAA","sourcesContent":[".iconWrapper {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
